import { useEffect as e, useRef as t } from "react";
//#region src/hooks/useAfterMount.ts
var n = (n, r) => {
	let i = t(!1);
	e(() => {
		i.current ? n() : i.current = !0;
	}, r);
};
//#endregion
export { n as default };

//# sourceMappingURL=useAfterMount.js.map